export const normalizeProductRawMaterialEntry = (entry) => {
  if (!entry) return { raw_material_name: '', characteristics: {}, required_qty: '' };
  const rawMaterialName = String(entry.raw_material_name || entry.type || '').trim();
  const characteristics = entry.characteristics && typeof entry.characteristics === 'object'
    ? entry.characteristics
    : (entry.category ? { Type: entry.category } : {});
  return {
    raw_material_name: rawMaterialName,
    characteristics,
    required_qty: entry.required_qty ?? ''
  };
};
